import React, { useEffect, useState } from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import Chart1 from './Chart1Dout'
import Chart3 from './Chart3HBar'
import Chart2 from './Chart2VBar'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'

export default function SyntheseTaches({ open, handleMesTaches, updateSynthese, updateTodo }) {
  const [tasks, setTasks] = useState([])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    fetchTasks()
  }, [updateSynthese])
  // useEffect(() => {
  //   fetchTasks()
  // }, [])
  const fetchTasks = async () => {
    const { data, status } = await makeGetRequest(urls.fetchTasks + '?limit=1000000', {}, true)
    if (status === 200) {
      setTasks(data)
    }
  }
  return (
    // <Box sx={{ width: open ? '85%' : '100%' }}>
    <Box display={'flex'} flexDirection={'column'} width={'100%'} mb={2}>
      <Box
        className=""
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          // display: 'grid',
          // gridTemplateColumns: { md: '0.5fr 2fr' },
          padding: isMobile ? '0 5px' : '0 25px',
          // gridGap: '10px',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: isMobile ? '100%' : '25%',
            background: '#083b67',
            padding: '15px',
            height: 390,
            borderRadius: '5px',
          }}
        >
          <Chart1 tasks={tasks} handleMesTaches={handleMesTaches} />
        </Box>
        <Box
          sx={{
            width: open ? (isMobile ? '100%' : '70%') : '100%',
            background: '#083b67',
            padding: '15px',
            height: 390,
            borderRadius: '5px',
          }}
        >
          <Chart2 tasks={tasks} handleMesTaches={handleMesTaches} />
        </Box>
      </Box>
      <Box
        className=""
        sx={{
          // display: 'grid',
          // gridTemplateColumns: { sm: '1fr' },
          padding: isMobile ? '0 5px' : '0 25px',
          width: open ? (isMobile ? '100%' : '96%') : '100%',
          marginTop: '10px',
        }}
      >
        <Box sx={{ width: '100%', background: '#083b67', padding: '15px', borderRadius: '5px' }}>
          <Chart3 tasks={tasks} handleMesTaches={handleMesTaches} updateTodo={updateTodo} />
        </Box>
      </Box>
    </Box>
  )
}
